<template>
  <section class="orderdatatable-grid accounts-datatables-grid">
    <impersonate-modal
      v-if="impersonateModal.isActive"
      :user="impersonateModal.activeUser"
      @close="closeImpersonationModal"
    />
    <account-users-modal
      v-if="usersModal.isActive"
      :company="usersModal.activeCompayName"
      :users="usersModal.users"
      @close-modal="closeUsersModal"
      @impersonate-modal="showImpersonateModal"
    />
    <acclaro-datatable
      ref="acclaroSearchView"
      grid-title="Accounts"
      search-route="/datatables/admin/accounts/data"
      filter-route="/datatables/admin/accounts/filters"
      datatable-name="accounts"
      :no-results-search-links="noResultsSearchLinks(false)"
      :column-templates="templates"
      :column-structure="columns"
      :options="datatableOptions"
    >

    <template v-slot:search="{query, placeholder, filterByKey, search, onFilter}">
      <acclaro-search-bar
          :selected-filter-key="filterByKey"
          :placeholder="'Search Accounts'"
          :search-query.sync="query"
          @filter-selected="onFilter"
          @update:searchQuery="(searchQuery, debounceTime) => search(searchQuery, null, debounceTime) "
          :show-dropdown="false"/>
    </template>
  </acclaro-datatable>
  </section>
</template>

<script>
import './styles/order-datatable.scss';
import './styles/accounts-datatable.scss';

import {
  AsLink,
  AsCell
} from '../Acclaro-Datatable/cells';

import { noResultsSearchLinks } from './helpers';
import AccountUsersModal from './components/AccountUsersModal';
import impersonateModal from './components/impersonateModal';
import moment from 'moment';

//console.log('modal', AccountUsersModal);

export default {

  props: {

    options: {
      type: Object,
      required: true
    }
  },

  components: {
      AccountUsersModal,
      impersonateModal
  },

  data () {
    return {

      impersonateModal: {
        isActive: false,
        activeUser: {}
      },

      usersModal: {
        isActive: false,
        activeCompayName: '',
        activeAccountId: null,
        users: []
      },

      datatableOptions: {
        orderBy: {},
        columnsClasses: {},
      },
    }
  },

  computed: {

    columns () {
      let columns = {
        company: { displayName: 'Account Name'},
        lastactivity: { displayName: 'Last Active'},
        users_count: { displayName: 'Users'},
        //projectmgr: { displayName: 'Program Mngr'},
      }

      return columns;
    },

    templates () {

      const orderViewRoute = this.options.orderViewRoute;
      let $vm = this;

      return {
        'Users': function (h, row, index) {
          const props = { row, column: 'Users'};

          return (
            <AsCell props={props}>
                <a class="clickable" onClick={() => $vm.getAccountUsers(row.account_id, row.company)}>{row.users_count}</a>
            </AsCell>
          );
        },

        'Account Name': function (h, row, index) {
          return (
            <div>
            <AsLink
              link={'/admin/account/details/' + row.account_id}
              link-text={row.company}
              new-tab={false}
            />
            </div>
          );
        },

      }
    }
  },

  methods: {

    noResultsSearchLinks,

    closeImpersonationModal () {
      this.impersonateModal.isActive = false;
    },

    showImpersonateModal (payload) {
      let {user} = payload;

      this.impersonateModal.isActive = true;
      this.impersonateModal.activeUser = user;
    },

    closeUsersModal () {
      this.setUsersModalData([], {accountId: null, company: ''}, false);
    },

    setUsersModalData (users, account, isActive = false) {
      let {accountId, company} = account;

      this.usersModal.users = users;
      this.usersModal.activeAccountId = accountId;
      this.usersModal.activeCompayName = company;
      this.usersModal.isActive = isActive;
    },

    getAccountUsers (accountId, company) {
        axios.get(`/admin/accounts/users?id=${accountId}`).then(result => {
            this.setUsersModalData(result.data, {accountId, company}, true)
        })
    },

    formatDate (date) {
      if (!moment(date).isValid()) return '-';

      return moment(date).format('DD-MMM-YYYY')
    },
  }
}
</script>
